import { UserPermissions } from "v2/api/types";
import { SingleTopBarNavigationElement } from "./singleTopBarNavigationElement";
import { assets } from "@upptic/module-ui";

export const getTopBarNavigationElements = (
  clientCode?: string,
): SingleTopBarNavigationElement[] => [
  {
    label: "Dashboard",
    url: "/dashboard",
    permission: UserPermissions.moduleDashboard,
  },
  {
    label: "Growth",
    url: `/${clientCode}/ua`,
    permission: UserPermissions.moduleUA,
    component: assets.GrowthLogo,
  },
  {
    label: "Creative",
    url: `/${clientCode}/creative`,
    permission: UserPermissions.moduleCreative,
    component: assets.CreativeLogo,
  },
  {
    label: "Social",
    url: `/${clientCode}/social`,
    permission: UserPermissions.moduleSocial,
    component: assets.SocialLogo,
  },
  {
    label: "ASO",
    url: "/applications",
    permission: UserPermissions.moduleASO,
    component: assets.ASOLogo,
  },
  {
    label: "Admin",
    url: `/${clientCode}/upptic`,
    permission: UserPermissions.moduleUpptic,
    component: assets.AdminLogo,
  },
];

export const getMobileTopBarNavigationElements = (
  clientCode?: string,
): SingleTopBarNavigationElement[] => [
  {
    label: "Dashboard",
    url: "/dashboard",
    permission: UserPermissions.moduleDashboard,
  },
  {
    label: "Growth",
    url: `/${clientCode}/ua`,
    permission: UserPermissions.moduleUA,
    component: assets.GrowthLogo,
  },
  {
    label: "Creative",
    url: `/${clientCode}/creative`,
    permission: UserPermissions.moduleCreative,
    component: assets.CreativeLogo,
  },
  {
    label: "Social",
    url: `/${clientCode}/social`,
    permission: UserPermissions.moduleSocial,
    component: assets.SocialLogo,
  },
  {
    label: "ASO",
    url: "/applications",
    permission: UserPermissions.moduleASO,
    component: assets.ASOLogo,
  },
  {
    label: "Admin",
    url: `/${clientCode}/upptic`,
    permission: UserPermissions.moduleUpptic,
    component: assets.AdminLogo,
  },
  {
    label: "Hub",
    url: `/${clientCode}/hub/overview`,
    permission: UserPermissions.readHubOverview,
  },
];
